import './BotSetup.scss';
import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useProtectedInterval } from '../../hooks/useProtectedInterval';
import CopyButton from '../../components/CopyButton/CopyButton';

export default function BotSetup() {
    const { t } = useTranslation('layout');
    const api_url = useSelector((state) => state.API_URL);

    const [botData, setBotData] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchBot = useCallback(async () => {
        const jwtToken = localStorage.getItem('accessToken');
        if (!jwtToken) return;
        try {
            const response = await fetch(api_url + 'teamlead/bot/', {
                headers: { 'Authorization': `JWT ${jwtToken}`, 'Content-Type': 'application/json' },
            });
            if (response.ok) {
                setBotData(await response.json());
            }
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    }, [api_url]);

    useProtectedInterval(fetchBot, [api_url]);

    if (loading) return <div style={{ padding: '24px' }}><h2>{t('sidebar.menu.botSetup')}</h2><p>Загрузка...</p></div>;

    return (
        <div className="BotSetup">
            <h2>{t('sidebar.menu.botSetup')}</h2>

            <div className="BotSetup__card">
                {!botData?.exists ? (
                    <div className="BotSetup__empty">
                        <div className="BotSetup__empty-icon">🤖</div>
                        <h3>Бот не настроен</h3>
                        <p>Notifier Bot ещё не создан для вашего аккаунта. Обратитесь к администратору для настройки.</p>
                    </div>
                ) : (
                    <div className="BotSetup__info">
                        <div className="BotSetup__row">
                            <span className="BotSetup__label">Статус</span>
                            <span className={`BotSetup__status BotSetup__status--${botData.is_active ? 'active' : 'inactive'}`}>
                                {botData.is_active ? 'Активен' : 'Неактивен'}
                            </span>
                        </div>

                        {botData.bot_username && (
                            <div className="BotSetup__row">
                                <span className="BotSetup__label">Username бота</span>
                                <span className="BotSetup__value">
                                    @{botData.bot_username}
                                    <CopyButton text={`@${botData.bot_username}`} />
                                </span>
                            </div>
                        )}

                        <div className="BotSetup__row">
                            <span className="BotSetup__label">Webhook</span>
                            <span className={`BotSetup__status BotSetup__status--${botData.webhook_enabled ? 'active' : 'inactive'}`}>
                                {botData.webhook_enabled ? 'Включён' : 'Выключен'}
                            </span>
                        </div>

                        {botData.bot_username && (
                            <div className="BotSetup__row">
                                <span className="BotSetup__label">Ссылка для трейдеров</span>
                                <span className="BotSetup__value">
                                    <a href={`https://t.me/${botData.bot_username}`} target="_blank" rel="noreferrer">
                                        t.me/{botData.bot_username}
                                    </a>
                                    <CopyButton text={`https://t.me/${botData.bot_username}`} />
                                </span>
                            </div>
                        )}

                        <div className="BotSetup__hint">
                            <p>Трейдеры привязываются к боту через команду <code>/start</code> с их кодом активации.</p>
                            <p>Для изменения настроек бота обратитесь к администратору.</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
